import isEmpty from 'lodash/isEmpty'
import * as React from 'react'
import {connect} from 'react-redux'
import {Alert} from 'reactstrap'
import * as Redux from 'redux'
import * as Actions from './actions'
import './styles.css'
import * as Types from './types'

interface StateProps { flash: Types.State }
interface DispatchProps { clearFlash: () => Redux.Action }
type Props = StateProps & DispatchProps

export const FlashPure = ({flash, clearFlash}: Props) =>
  <Alert className="flash" color={flash.color} isOpen={!isEmpty(flash.message)} toggle={clearFlash}>
    {flash.message}
  </Alert>

export const FlashMessage = connect(
  ({flash}: Props) => ({flash}),
  {clearFlash: Actions.clearFlash},
)(FlashPure)



// WEBPACK FOOTER //
// ./src/components/flash-message/component.tsx